module.exports = __webpack_public_path__ + "media/slot-game/burger-1-9cc51454.svg";